<div class="qr-code-box">
  <qr-code-preview [qr]="qrSVG" [canCopy]="false"></qr-code-preview>
</div>
<div class="hg-text">
  <strong>{{ 'findContent.mobileAppInfo.header' | translate }}</strong>
  <span>{{ 'findContent.openInAppNowButton' | translate }}</span>
</div>
<div class="small-icon">
  <mat-icon>install_mobile</mat-icon>
</div>
